import { useEffect, useState } from "react";
import { Button } from "@/components/ui/button";
import { typeColor, textOn } from "@/lib/typeColors";

export function TypeColorsEditor({ settings, onSave }) {
  const types = settings.service_types || [];
  const [colors, setColors] = useState({});

  useEffect(() => {
    setColors(Object.fromEntries(types.map((t) => [t, typeColor(t, settings)])));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [JSON.stringify(types), JSON.stringify(settings.service_type_colors || {})]);

  return (
    <div className="rounded-xl border border-border bg-card p-6 md:col-span-2" data-testid="type-colors-editor">
      <h3 className="font-display text-lg font-semibold mb-1">Colori dei tipi di servizio</h3>
      <p className="text-xs text-muted-foreground mb-4">Scegli il colore dell'etichetta e della riga in cima alla scheda. Il testo diventa nero o bianco in automatico per restare leggibile.</p>
      <div className="grid sm:grid-cols-2 gap-3">
        {types.map((t) => {
          const c = colors[t] || "#475569";
          return (
            <label key={t} className="flex items-center gap-3 rounded-lg border border-border px-3 py-2 cursor-pointer hover:bg-muted transition-colors">
              <input type="color" data-testid={`type-color-${t}`} value={c} onChange={(e) => setColors((p) => ({ ...p, [t]: e.target.value }))}
                className="h-9 w-12 cursor-pointer rounded border border-border bg-transparent p-0.5" />
              <span className="rounded-md px-2.5 py-1 text-xs font-bold uppercase tracking-wider" style={{ backgroundColor: c, color: textOn(c) }}>{t}</span>
              <span className="ml-auto font-mono text-xs text-muted-foreground">{c}</span>
            </label>
          );
        })}
      </div>
      <Button data-testid="type-colors-save" onClick={() => onSave({ service_type_colors: colors })} className="rounded-full font-semibold mt-4">Salva colori</Button>
    </div>
  );
}
